module.exports = {
    //Subscription
    DONOT_HAVE_SUBSCRIPTION: "You don’t have any active subscription plan.",

    //Manage Dev Plans
    DONOT_CANCEL_SUBSCRIPTION: "Are you sure you don't want to cancel this subscription?",
    PLAN_VALIDATION: "Please select plan.",
    CANCEL_MONTHLY_SUBSCRIPTION: "Are you sure you want to cancel this subscription?",
    CANCEL_YEARLY_SUBSCRIPTION: "Please contact support at hello@weam.ai or chat with us to cancel your subscription.",
    CHANGE_REQUEST_SCHEDULED: "Plan Change Request Scheduled",
    DONOT_HAVE_DEV_PLAN: "You do not have any active Dev Plan",
    CANCEl_PERSONALIZE_DEV_ADDON: "Are you sure you want to cancel this personalize dev addon?",

    //Manage Site Add-Ons
    REMOVE_ADDONS: "Are you sure you want to remove this add-on?",

    //Upcomming Invoice
    PENDING_SUBSCRIPTION: "Your subscription is pending for cancellation on",

    //Update Card
    DELETE_CARD: "Are you sure you want to delete this card?",
    DEFAULT_CARD: "Are you sure you want to set this card as default card?",   
}